import { APIProvider, Map, Polygon, Circle } from "@vis.gl/react-google-maps";

import { useEffect, useState } from "react";

import { Icon } from "@mui/material";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";

import AppConfig from "appConfig";

const DEFAULT_CENTER = {
  lat: 6.5244,
  lng: 3.3792,
};

function BoundaryMap({ coordinates = [], onChange }) {
  const [paths, setPaths] = useState(coordinates || []);

  useEffect(() => {
    setPaths(coordinates || []);
  }, [coordinates]);

  const handleMapClick = (event) => {
    const latLng = event.detail?.latLng;

    if (!latLng) {
      return;
    }

    const newPoint = {
      lat: latLng.lat,
      lng: latLng.lng,
    };

    const newPaths = [...paths, newPoint];

    setPaths(newPaths);

    onChange(newPaths);
  };

  const clearBoundary = () => {
    setPaths([]);

    onChange([]);
  };

  return (
    <MDBox>
      {/* Controls */}
      <MDBox mt={2} display="flex" justifyContent="space-between" alignItems="center">
        <MDBox>
          <MDTypography variant="button" color="text">
            {paths.length} point
            {paths.length === 1 ? "" : "s"}
          </MDTypography>

          <MDTypography display="block" variant="caption" color="text">
            Click on the map to add points. Once you have at least 3 points, drag the polygon points
            to adjust the boundary.
          </MDTypography>
        </MDBox>

        {paths.length > 0 && (
          <MDButton
            size="small"
            variant="outlined"
            color="error"
            onClick={clearBoundary}
            startIcon={<Icon>delete</Icon>}
          >
            Clear
          </MDButton>
        )}
      </MDBox>

      {/* Map */}
      <MDBox
        mt={2}
        sx={{
          width: "100%",
          height: "450px",
          overflow: "hidden",
          borderRadius: "8px",
          border: "1px solid #e0e0e0",
        }}
      >
        <APIProvider apiKey={AppConfig.google_map_key}>
          <Map
            defaultCenter={DEFAULT_CENTER}
            defaultZoom={12}
            gestureHandling="greedy"
            clickableIcons={false}
            mapTypeControl={true}
            streetViewControl={false}
            fullscreenControl={true}
            onClick={handleMapClick}
            style={{
              width: "100%",
              height: "100%",
            }}
          >
            {/* Show every clicked point */}
            {paths.map((point, index) => (
              <Circle
                key={`${point.lat}-${point.lng}-${index}`}
                center={point}
                radius={16}
                clickable={false}
                fillOpacity={1}
                strokeOpacity={1}
                strokeWeight={2}
              />
            ))}

            {/* Draw polygon after 3 points */}
            {paths.length >= 3 && (
              <Polygon
                paths={paths}
                editable={true}
                draggable={false}
                clickable={false}
                fillOpacity={0.25}
                strokeOpacity={1}
                strokeWeight={2}
              />
            )}
          </Map>
        </APIProvider>
      </MDBox>
    </MDBox>
  );
}

export default BoundaryMap;
